import React, { ReactNode } from 'react';
import classNames from 'classnames';
import Icon, { COLORS, ICONS, IconType } from '../icon';
import './button.scss';

type TTagName =
	| 'a'
	| 'button'
	| 'span'
	| 'div';

interface Props {
	children: ReactNode;
	classButton?: string;
	url?: string;
	template?: string;
	isRound?: boolean;
	isSmall?: boolean;
	tagName?: TTagName;
	type?: 'primary';
	typeBtn?: string;
	isDisabled?: boolean;
	onClick?: (e?: any) => void;
	icon?: { name: IconType };
	ariaLabel?: string;
}

export const Button = ({
	children,
	classButton,
	url,
	template,
	isRound,
	isSmall,
	tagName = 'button',
	type,
	typeBtn,
	isDisabled,
	onClick,
	icon,
	ariaLabel,
}: Props): JSX.Element => {
	const TagName = `${tagName}` as keyof JSX.IntrinsicElements;
	return (
		<TagName
			onClick={onClick}
			href={url ? url : undefined}
			type={typeBtn as any}
			role={typeBtn === 'button' ? 'button' : undefined}
			aria-label={ariaLabel}
			target={tagName === "a" ? "_blank" : undefined}
			className={classNames({
				round: isRound,
				small: isSmall,
				primary: type === 'primary',
			}, classButton, template ? template + ' evt-button' : '', isDisabled ? ' disabled' : '')}
		>
			{icon && (
				<Icon name={ICONS[icon.name]} size={16} color={COLORS.WHITE} />
			)}
			{children}
		</TagName>
	);
};
